import pathToRegexp from 'path-to-regexp';
import { createElement, FC } from 'react';
import ReactDocumentTitle from 'react-document-title';
import { useRecoilValue } from 'recoil';

import { Consumer as StateConsumer } from '../context/state';
import { projectAtom } from '../page/ProjectEditingPage/atoms/projectAtom';

const DocumentTitle: FC = () => {
  const project = useRecoilValue(projectAtom);

  return (
    <StateConsumer>
      {(state) => {
        const location = state.location;
        let title: string | null = null;

        if (state.authentication.fetching >= 1) {
          title = 'Signing in...';
        } else if (location.pathname === '/settings') {
          title = 'Settings';
        } else if (pathToRegexp('/organizations/:organizationId/projects').test(location.pathname)) {
          title = 'Projects';
        } else if (pathToRegexp('/projects/:projectId/edit').test(location.pathname)) {
          if (project) {
            if (project?.state !== 'submitted') {
              title = 'New Project';
            } else {
              title = 'Edit Project';
            }
          } else {
            title = 'Loading...';
          }
        } else if (pathToRegexp('/projects/:projectId/:tabName').test(location.pathname)) {
          if (state.project.project || project) {
            title = `Project #${state.project.project?.id || project?.id} ${
              state.project.project?.title || project?.title
            }`;
          } else {
            title = 'Loading...';
          }
        } else if (pathToRegexp('/creations/:creationId').test(location.pathname)) {
          if (state.creation.creation) {
            title = `Creative #${state.creation.creation.id}`;
          } else {
            title = 'Loading...';
          }
        }

        if (title === null) {
          title = 'Kaizen Ad';
        } else {
          title = `${title} | Kaizen Ad`;
        }

        return <ReactDocumentTitle title={title} />;
      }}
    </StateConsumer>
  );
};
export default DocumentTitle;
